import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import { HelperService } from './helper.service';
import { API_ENDPOINTS } from '../../shared/constants/api-endpoints';
import { Project } from '../../shared/models/project.mode';
import { ProjectStatus } from '../../shared/models/project-status.model';

@Injectable({
  providedIn: 'root',
})
export class CatalogService extends BaseService {
  constructor(
    public override http: HttpClient,
    private readonly helperService: HelperService,
  ) {
    super(http);
  }

  public getResearchProjects(statuses: Array<number>): Observable<ReadonlyArray<Project>> {
    let url = this.helperService.prepareAPIURLBasedOnRegions();
    url = `${url}${API_ENDPOINTS.catalogUrl}/projects?statuses=3`;
    for (const status of statuses) {
      url += `&statuses=${status}`;
    }
    return this.baseGet<ReadonlyArray<Project>>(url);
  }

  public getProjectStatuses(): Observable<Array<ProjectStatus>> {
    let url = this.helperService.prepareAPIURLBasedOnRegions();
    url = `${url}${API_ENDPOINTS.catalogUrl}/projects/project-statuses`;
    return this.http.get<Array<ProjectStatus>>(url);
  }

  public getShareCompanyTypes(projectCode: string): Observable<Array<any>> {
    let url = this.helperService.prepareAPIURLBasedOnRegions();
    url = `${url}${API_ENDPOINTS.sharesUrl}/projects/${projectCode}/share-company-types`;
    return this.baseGet<Array<any>>(url);
  }

  public getDataTypes(projectCode: string): Observable<Array<{ id: number; name: string }>> {
    let url = this.helperService.prepareAPIURLBasedOnRegions();
    url = `${url}${API_ENDPOINTS.sizesUrl}/projects/${projectCode}/data-types`;
    return this.http.get<Array<{ id: number; name: string }>>(url);
  }

  public getAllProjects(): Observable<ReadonlyArray<Project>> {
    let url = this.helperService.prepareAPIURLBasedOnRegions();
    url = `${url}${API_ENDPOINTS.catalogUrl}/projects?statuses=3&statuses=4`;
    return this.baseGet<ReadonlyArray<Project>>(url);
  }
}
